import axios from '@/js/helper/axios-helper.js'
import { stringify } from 'qs'

import { types as STORE_MODULES } from '@/js/plugins/store/store-modules'
import APP_GETTER from '@/js/plugins/store/modules/app/getter-types'

import FormDataTransformer from '../transformer/transform-post-data'

import ACTION_TYPES from './action-types'
import MUTATION_TYPES from './mutation-types'
import GETTER_TYPES from './getter-types'

const API_CONSTANTS = {
  CODE: 'code',
  CODES: {
    CREATE_TICKET: 'create-ticket',
  },
}

export default {
  [ACTION_TYPES.CREATE_TICKET]: async ({ commit, getters, rootGetters }) => {
    commit(MUTATION_TYPES.SET_FORM_PENDING, true)
    commit(MUTATION_TYPES.SET_FORM_SUCCESSFUL_SUBMITTED, false)
    commit(MUTATION_TYPES.RESET_FORM_ERRORS)

    const url = `${rootGetters[`${STORE_MODULES.APP}/${APP_GETTER.RETURN_API_URL}`]}?${stringify({
      [API_CONSTANTS.CODE]: API_CONSTANTS.CODES.CREATE_TICKET,
    })}`
    const data = FormDataTransformer(getters[GETTER_TYPES.FORM_DATA])
    const options = { method: 'POST', url, data }

    try {
      const response = await axios(options)
      const { data } = response

      commit(MUTATION_TYPES.SET_FORM_SUCCESSFUL_SUBMITTED, true)

      return data
    } catch (error) {
      const { response } = error
      if (response.status >= 500) {
        return commit(MUTATION_TYPES.ADD_FORM_ERROR, response.statusText)
      }

      if (response.status >= 400) {
        const {
          data: { error = { message: '' } },
        } = response

        const { messages } = error

        return messages.map(message => commit(MUTATION_TYPES.ADD_FORM_ERROR, message))
      }

      return console.log(error)
    } finally {
      commit(MUTATION_TYPES.SET_FORM_PENDING, false)
    }
  },

  [ACTION_TYPES.GET_BIKE_COMPONENT_DATA]: async ({ commit, rootGetters }, serialNumber) => {
    try {
      const bikeResponse = await axios.get(
        `/api/bucommonapi?code=complaint-components&serialnumber=${serialNumber}&language=${
          rootGetters[`${STORE_MODULES.APP}/${APP_GETTER.LOCALE}`]
        }`,
      )
      commit(MUTATION_TYPES.SET_BIKE_COMPONENT_DATA, bikeResponse.data)
      return bikeResponse.data
    } catch (error) {
      commit(MUTATION_TYPES.SET_BIKE_COMPONENT_DATA, {})
      commit(MUTATION_TYPES.UPDATE_FORM_DATA, { claim: [] })
      return {}
    }
  },
}
